import styled from 'styled-components';

export const AttachmentButton = styled.button`
  padding: ${({ theme }) => theme.yoga.spacing.zero};
  border: ${({ theme }) => theme.yoga.boards.zero};
  display: flex;
  cursor: pointer;
  align-items: center;
  background-color: transparent;
  margin-right: ${({ theme }) => theme.yoga.spacing.xsmall}px;

  svg {
    fill: ${({ theme }) => theme.yoga.colors.elements.selectionAndIcons};
  }
`;
